export default __webpack_public_path__ + "static/media/mus-crossthestreet.7c388b86.mp4";